export default class GTM {
     // Constructor
     constructor() {
        this.cards = null;
    }

    // Init before frameworks
    init() {
        this.cards = document.querySelectorAll('.tps-gtm-card');
        this.setEvent_cardClicked();
    }

    // Init after frameworks
    initAfterFrameworks() { }

    // Destroy
    destroy() {
    }

    setEvent_cardClicked() {
        const self = this;
        
        self.cards.forEach(function(card) {
            card.addEventListener('click', function(e) {
                const category = card.dataset.gtmCategory;
                const action = card.dataset.gtmAction;
                const label = card.dataset.gtmLabel;

                self.dataLayerPush({
                    'event' : 'cardClick',
                    'cardCategory' : category,
                    'cardAction' : action,
                    'cardLabel' : label,
                });
            });
        });
    }

    dataLayerPush(obj) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(obj);
    }
}